function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useRef } from 'react';
import * as comlink from 'comlink';
import postIframeForm from '../../util/postIframeForm';
import useUpdateData from './utils/useUpdateData';
import { replaceStagingUrl } from "../../util/url";
const HostIframe = _ref => {
  let {
    iFrameProps,
    src,
    postForm = false,
    iFrameRef,
    // shallow data
    pages,
    isAdminModeActive,
    site,
    user,
    currentPage,
    functions,
    device,
    language,
    parameters,
    environment,
    customData,
    preventStagingReplacement,
    dialog
  } = _ref;
  const eventTarget = useRef();
  const ref = useRef();
  const currentDataRef = useRef();
  if (!eventTarget.current) {
    eventTarget.current = global.document ? document.createElement('div') : undefined; // global.EventTarget ? new EventTarget() : undefined
  }

  const setHeight = value => {
    if (ref.current) {
      ref.current.style.height = `${value}px`;
    }
  };

  // region initialData
  const initialData = {
    site,
    isAdminModeActive,
    pages,
    currentPage,
    device,
    user,
    language,
    parameters,
    environment,
    customData,
    dialog
  };
  // endregion

  currentDataRef.current = initialData;

  // region postIframeForm
  useEffect(() => {
    (async () => {
      if (postForm) {
        var _await$functions$getA;
        const accessToken = (_await$functions$getA = await functions.getAccessToken()) !== null && _await$functions$getA !== void 0 ? _await$functions$getA : {};
        void postIframeForm(replaceStagingUrl(preventStagingReplacement, src, environment.buildEnvironment), JSON.stringify({
          ...initialData,
          pages: undefined,
          ...accessToken
        }), 'chayns', iFrameProps.name);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // endregion

  // region expose data and functions to iframe
  useEffect(() => {
    var _ref$current;
    if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contentWindow) {
      const obj = {
        [iFrameProps.name]: {
          functions: {
            ...functions,
            setHeight
          },
          addDataListener: cb => {
            if (eventTarget.current) eventTarget.current.addEventListener('data_update', e => e.detail && cb(e.detail));
          },
          getInitialData: () => currentDataRef.current
        }
      };
      comlink.expose(obj, comlink.windowEndpoint(ref.current.contentWindow));
      ref.current.contentWindow.postMessage('chayns-api-host-ready', '*');
      // https://github.com/GoogleChromeLabs/comlink/pull/469 might be better approach once released
      return () => {
        delete obj[iFrameProps.name];
      };
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // endregion

  // region dispatch data update
  useUpdateData(eventTarget.current, 'isAdminModeActive', isAdminModeActive);
  useUpdateData(eventTarget.current, 'user', user);
  useUpdateData(eventTarget.current, 'site', site);
  useUpdateData(eventTarget.current, 'pages', pages);
  useUpdateData(eventTarget.current, 'language', language);
  useUpdateData(eventTarget.current, 'parameters', parameters);
  useUpdateData(eventTarget.current, 'environment', environment);
  useUpdateData(eventTarget.current, 'customData', customData);
  useUpdateData(eventTarget.current, 'dialog', dialog);
  // endregion

  return /*#__PURE__*/React.createElement("iframe", _extends({
    ref: r => {
      ref.current = r;
      if (iFrameRef) {
        // eslint-disable-next-line no-param-reassign
        iFrameRef.current = r;
      }
    },
    title: " "
  }, iFrameProps, {
    src: postForm ? undefined : replaceStagingUrl(preventStagingReplacement, src, environment.buildEnvironment)
  }));
};
export default HostIframe;